/* eslint-disable @typescript-eslint/ban-types */
import React from 'react';
import { Cell, ColumnInterface } from 'react-table';

import { getProDisplayName } from '@trqk/utils';

import { defaultCellWidth } from '../constants';

interface Props<D extends object> {
    cell: Cell<D>;
    column: ColumnInterface<D>;
}

/**
 * Renders the PRO name; appends "Intl." for ASCAP statements where region is "international".
 */
export function PRONameCell<D extends object>({
    cell,
    column,
}: Props<D>): JSX.Element {
    const width = (column?.width as number) ?? defaultCellWidth;
    const {
        value: { pro, region },
    } = cell;

    const displayName = getProDisplayName(pro, region);

    return (
        <div
            className="respond-to-mouse"
            style={{
                width,
            }}
        >
            {displayName}
        </div>
    );
}
